import { render, staticRenderFns } from "./VideoUploadModal.vue?vue&type=template&id=623c7b63&scoped=true"
import script from "./VideoUploadModal.vue?vue&type=script&lang=ts"
export * from "./VideoUploadModal.vue?vue&type=script&lang=ts"
import style0 from "./VideoUploadModal.vue?vue&type=style&index=0&id=623c7b63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623c7b63",
  null
  
)

export default component.exports